import axios from 'axios';
import config from 'config/config';
import { AuthToken } from 'data/api/auth-token';
import { convertToFormData } from '../RequestDeal.js';
import { LangStore } from 'extensions/i18n';

const http = axios.create({
  baseURL: config.futureUrl,
  validateStatus: (status) => (status >= 200 && status < 300) || status >= 400,
  headers: {
    'X-SITE-ID': 127,
  },
});

http.interceptors.request.use(
  (config) => {
    const token = AuthToken.getToken();
    if (token) {
      config.headers['x-auth-token'] = token;
    }

    let lang = LangStore.getLang() || 'en';

    config.headers['lang'] = lang;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

http.interceptors.response.use(
  (response) => {
    const { data, code, message } = response.data;

    if (response.data.error) {
      throw response.data.message;
    }

    if (!data && typeof code === 'undefined') {
      return response.data;
    }

    if (code === 0) {
      return data;
    }

    // 登录失效
    // if (code === 4000)

    const error = new Error(message);
    error.statusCode = response.status;
    error.resCode = code;
    error.config = response.config;
    throw error;
  },
  (error) => {
    throw error;
  },
);

function post(url, data) {
  return new Promise((resolve, reject) => {
    http({
      method: 'post',
      url,
      data,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function get(url, data) {
  return new Promise((resolve, reject) => {
    http({
      method: 'get',
      url,
      data,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function postForm(url, data) {
  const formData = convertToFormData(data);
  return new Promise((resolve, reject) => {
    http({
      method: 'post',
      url,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export { post, get, postForm };
